import { ACHTransferValues, PREVIOUS } from './types'
import { generateExternalTransferId } from '../../utils/payloadHelpers'
import { TransferDirection } from '../../api/useAchSubmission'
import { IraConstraintsResponsePayload, AchPayload } from '@Types'
import { convertToValidDate } from '../../utils'
import { getFrequencyInterval } from './utils/getFrequencyInterval'
import { getFrequencyUnit } from './utils/getFrequencyUnit'
import isEmpty from 'lodash.isempty'
import { getFeeOverrideDetails } from '../TransferFees/utils/getFeeOverrideDetails'
const formatPayload = (
  {
    totalBalanceCheckbox,
    transferAmountRaw,
    federalTaxWithholdingAmountRaw,
    federalTaxWithholdingType,
    distributionReason,
    stateTaxWithholdingAmountRaw,
    stateTaxWithholdingType,
    contributionType,
    contributionYear,
    transferStartDate,
    transferRecurrence,
    transferFrequency,
    numberOfTransfers,
    transferScheduledDate,
    whenToSend,
    fees,
    optOutFormProvided
  }: ACHTransferValues,
  transferDirection: TransferDirection,
  isScheduledTransfer: boolean,
  iraConstraints?: IraConstraintsResponsePayload | null,
  relationshipId?: string
): AchPayload => {
  return {
    externalId: generateExternalTransferId(),
    ...(!isScheduledTransfer && { relationshipId: relationshipId }),
    ...(isScheduledTransfer && { achRelationshipId: relationshipId }),
    ...(!totalBalanceCheckbox && { amount: transferAmountRaw }),
    ...(totalBalanceCheckbox && { isFullDisbursement: true }),
    ...(transferDirection === 'withdrawals' &&
      !!iraConstraints?.distributionConstraints && {
        [isScheduledTransfer ? 'iraDistributionDetails' : 'iraDistribution']: {
          distributionReason,
          ...(federalTaxWithholdingAmountRaw && {
            federalTaxWithholding: {
              value: federalTaxWithholdingAmountRaw,
              valueType: federalTaxWithholdingType
            }
          }),
          ...(stateTaxWithholdingAmountRaw && {
            stateTaxWithholding: {
              value: stateTaxWithholdingAmountRaw,
              valueType: stateTaxWithholdingType
            }
          }),
          ...(optOutFormProvided && { hasStateWithholdingWaiver: optOutFormProvided })
        }
      }),
    ...(transferDirection === 'deposits' &&
      !!iraConstraints?.contributionConstraints && {
        [isScheduledTransfer ? 'iraContributionDetails' : 'iraContribution']: {
          type: contributionType,
          applyToPriorYear: contributionYear === PREVIOUS
        }
      }),
    ...(isScheduledTransfer && {
      ...(transferRecurrence === 'RECURRING' && {
        startDate: convertToValidDate(transferStartDate),
        frequencyUnit: getFrequencyUnit(transferFrequency),
        frequencyInterval: getFrequencyInterval(transferFrequency),
        ...(numberOfTransfers &&
          Number(numberOfTransfers) > 0 && {
            occurrences: Number(numberOfTransfers)
          })
      }),
      ...(transferRecurrence === 'ONE_TIME' && {
        startDate: convertToValidDate(transferScheduledDate),
        frequencyUnit: 'DAY',
        frequencyInterval: 1,
        ...(whenToSend === 'IN_THE_FUTURE' && { occurrences: 1 }),
        ...(whenToSend === 'IMMEDIATELY' &&
          numberOfTransfers &&
          Number(numberOfTransfers) > 0 && {
            occurrences: Number(numberOfTransfers)
          })
      })
    }),
    ...(!isEmpty(fees) && { feeOverrideDetails: getFeeOverrideDetails(fees) })
  }
}

export default formatPayload
